import type {BioIconProps} from '../../icons/common-types'

export default function Top10WorthItLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 728.00 728.00" {...attributes}>
        <path
          fill="#ffffff"
          d="
  M 322.86 102.44
  Q 322.87 102.40 324.17 99.28
  Q 333.41 77.02 341.96 55.86
  Q 343.52 52.01 348.79 39.07
  Q 351.54 32.32 354.21 30.08
  Q 358.57 26.43 364.27 26.06
  A 6.80 6.80 0.0 0 1 367.19 26.51
  Q 371.60 28.25 371.96 28.48
  C 373.88 29.70 376.05 32.20 377.23 34.70
  Q 381.59 43.97 383.06 48.15
  Q 383.21 48.55 387.11 58.32
  Q 390.81 67.59 394.62 76.68
  Q 398.26 85.36 402.19 94.97
  Q 416.12 129.15 430.12 162.82
  Q 438.81 183.75 452.33 217.45
  C 454.40 222.61 456.53 226.93 458.70 232.38
  C 459.53 234.46 460.74 236.46 462.07 238.18
  Q 465.03 242.02 470.77 241.92
  Q 477.25 241.80 480.88 242.46
  C 485.01 243.20 489.25 242.59 492.63 243.33
  C 497.25 244.35 503.27 243.85 508.31 244.86
  C 511.29 245.45 516.25 244.94 520.21 245.55
  C 524.94 246.28 530.22 246.07 535.22 246.91
  A 16.29 15.76 -39.8 0 0 538.21 247.13
  Q 543.65 247.01 548.24 247.75
  Q 551.44 248.26 553.25 248.21
  C 558.07 248.06 562.52 249.07 567.09 249.23
  C 573.23 249.43 577.07 250.24 583.75 250.34
  C 586.86 250.39 590.15 251.34 592.87 251.32
  Q 599.14 251.29 601.36 251.78
  C 605.25 252.64 608.93 252.15 613.03 252.69
  Q 619.65 253.56 626.01 253.49
  C 627.56 253.48 629.63 254.10 631.51 254.22
  Q 650.70 255.41 654.82 255.94
  Q 659.91 256.60 663.18 256.56
  C 666.83 256.52 670.01 257.48 673.57 257.49
  Q 676.98 257.51 680.80 258.11
  Q 685.07 258.79 687.84 259.73
  Q 690.84 260.75 695.37 265.68
  A 3.50 3.25 13.1 0 1 695.95 266.54
  Q 700.68 276.71 692.54 284.09
  Q 678.69 296.65 649.90 321.41
  Q 624.88 342.94 619.10 347.87
  C 615.71 350.76 613.89 352.69 611.19 354.88
  Q 608.04 357.42 605.75 359.60
  Q 603.05 362.16 600.40 364.41
  Q 581.22 380.73 581.19 380.90
  Q 581.16 381.04 577.58 383.83
  Q 575.62 385.36 573.06 388.06
  C 571.94 389.24 570.66 389.84 569.53 390.85
  C 562.61 397.04 557.35 401.80 552.05 406.25
  Q 534.88 420.65 529.24 426.24
  Q 526.82 428.64 526.05 431.81
  Q 525.41 434.43 526.31 438.23
  Q 527.86 444.78 529.46 452.03
  Q 531.53 461.50 543.02 508.24
  Q 569.77 617.05 576.80 647.68
  Q 577.72 651.70 577.98 652.87
  Q 579.79 661.16 574.41 667.66
  Q 572.28 670.25 566.81 672.03
  A 2.66 2.65 -53.9 0 1 565.99 672.16
  L 559.71 672.16
  A 1.53 1.46 -32.2 0 1 559.12 672.04
  Q 556.84 671.05 555.54 670.53
  Q 554.34 670.05 552.47 668.88
  Q 547.39 665.69 534.28 657.41
  Q 532.21 656.10 491.43 629.59
  Q 476.63 619.97 470.30 615.57
  C 464.52 611.56 458.31 607.93 450.67 602.81
  Q 442.51 597.35 399.23 568.87
  Q 398.38 568.31 396.61 567.36
  Q 396.38 567.24 394.08 565.69
  Q 381.11 556.97 370.52 549.72
  Q 368.35 548.24 363.16 548.19
  A 2.24 2.23 -61.1 0 0 361.96 548.54
  L 174.46 670.25
  A 6.13 6.09 19.7 0 1 172.94 670.96
  L 169.85 671.89
  A 4.08 3.68 -54.6 0 1 168.73 672.14
  Q 161.86 672.69 157.74 670.57
  C 153.62 668.46 150.29 663.21 149.79 658.39
  Q 149.59 656.50 150.80 651.73
  Q 151.63 648.43 152.39 645.13
  Q 164.72 591.70 170.37 567.71
  Q 173.26 555.39 177.50 537.70
  Q 182.29 517.68 185.47 504.63
  Q 196.91 457.55 199.78 445.44
  C 200.57 442.11 200.78 440.02 201.55 436.76
  Q 202.65 432.16 199.99 427.20
  A 3.40 3.29 -83.4 0 0 199.40 426.43
  Q 192.27 419.45 186.16 414.54
  Q 180.92 410.33 180.45 409.66
  Q 180.02 409.03 174.56 404.62
  Q 171.89 402.46 168.52 399.43
  Q 155.16 387.36 141.48 376.03
  C 137.81 372.99 134.85 370.11 131.21 366.97
  Q 110.61 349.21 67.95 312.79
  Q 59.66 305.71 50.85 298.18
  Q 43.33 291.76 36.33 285.17
  C 31.62 280.74 28.15 275.45 30.96 268.76
  Q 33.61 262.44 40.66 259.80
  A 2.60 2.38 30.5 0 1 41.46 259.63
  Q 43.07 259.53 43.91 259.15
  C 45.94 258.24 48.02 258.69 50.35 257.97
  A 3.04 2.87 33.6 0 1 51.22 257.82
  C 62.25 257.38 71.65 256.30 82.53 255.65
  Q 89.99 255.21 90.98 255.07
  C 96.67 254.32 103.29 254.65 108.56 253.76
  C 112.28 253.14 116.21 253.43 120.80 253.00
  Q 132.12 251.95 137.89 251.55
  Q 144.21 251.11 152.59 250.32
  Q 163.89 249.24 167.31 249.21
  Q 170.67 249.18 174.14 248.43
  Q 175.86 248.06 180.06 248.20
  A 9.72 9.43 40.4 0 0 182.06 248.07
  Q 187.57 247.13 194.23 247.16
  C 198.07 247.18 202.40 246.20 205.92 246.18
  Q 210.68 246.16 213.43 245.78
  Q 218.60 245.05 220.10 245.10
  C 225.09 245.27 228.67 244.15 233.70 244.11
  C 237.75 244.07 241.58 243.26 245.89 243.09
  C 248.49 242.98 252.15 243.31 255.52 242.36
  Q 257.35 241.84 259.91 241.95
  A 1.44 1.41 33.1 0 0 260.61 241.81
  L 265.39 239.63
  A 3.90 3.89 89.2 0 0 267.36 237.60
  Q 277.12 214.68 281.31 204.27
  Q 286.67 190.97 291.09 180.53
  Q 296.32 168.17 300.79 156.76
  Q 305.41 144.98 310.38 133.22
  Q 315.41 121.30 319.88 109.65
  C 320.71 107.50 322.52 104.43 322.86 102.44
  Z
  M 244.73 382.68
  C 243.12 385.69 244.15 389.61 246.54 391.97
  Q 264.77 409.94 330.44 473.87
  Q 331.90 475.28 333.46 476.17
  C 337.53 478.47 340.55 478.21 343.92 474.92
  C 368.92 450.46 398.58 420.96 458.45 361.45
  Q 480.73 339.30 488.78 331.53
  C 493.22 327.24 498.52 322.06 493.24 316.76
  Q 481.23 304.73 474.28 297.62
  C 470.95 294.20 468.18 290.07 463.84 287.53
  A 0.53 0.46 56.9 0 0 463.59 287.46
  L 458.05 287.46
  A 0.78 0.78 0.0 0 0 457.54 287.65
  Q 452.65 291.75 452.35 292.10
  Q 448.84 296.18 445.00 299.76
  Q 442.86 301.75 438.34 306.08
  Q 435.86 308.45 433.58 310.99
  Q 430.75 314.15 428.89 315.98
  Q 421.50 323.24 414.54 330.29
  Q 399.58 345.45 386.74 357.54
  C 383.63 360.47 380.81 363.90 377.31 366.90
  C 376.04 367.99 374.88 369.69 373.65 370.90
  Q 360.87 383.42 343.32 401.05
  Q 339.52 404.87 334.29 404.23
  Q 329.18 403.61 326.40 401.08
  Q 324.34 399.20 282.74 357.74
  Q 278.93 353.94 274.27 354.79
  Q 271.22 355.34 266.84 360.20
  Q 265.21 362.01 249.86 377.07
  C 248.12 378.78 246.04 380.22 244.73 382.68
  Z"
        />
      </svg>

      <span>Top 10 Worth It</span>
    </div>
  )
}
